export default class TpClientInvoiceJobLineMultiEditItem {
  constructor(invoiceCurrencyCode = '', fieldworkCurrencies = [], evaluatorCurrencies = []) {
    // The group is written only when the user switches this on; an empty field must not clear the
    // groups of every selected job when only the amounts are edited.
    this.AdHocGroupEnabled = false;
    this.AdHocGroup = null;
    this.FieldworkFee = null;
    this.ClientFee = null;
    this.ClientTravel = null;
    this.AdditionalClientFee = null;
    this.ClientMisc = null;
    this.ClientReimbursement = null;
    this.ClientGaming = null;

    this.EvaluatorFee = null;
    this.EvaluatorTravel = null;
    this.AdditionalEvaluatorFee = null;
    this.EvaluatorMisc = null;
    this.EvaluatorReimbursement = null;
    this.EvaluatorGaming = null;

    // Client amounts are typed in the invoice currency - the one the grid shows - and the server
    // converts them into each job line's own currency on save where the two differ, so one invoice
    // is always one label. Display only; the server does not need it.
    this.ClientCurrencyCode = invoiceCurrencyCode;
    // The fieldwork fee is the exception: it is stored verbatim in the job's pricing currency (the
    // grid's FW Fee column), so like the evaluator amounts it needs exactly one currency across the
    // selection. The server re-checks this across the full selection.
    this.FieldworkCurrencies = fieldworkCurrencies;
    this.FwCurrencyCode = fieldworkCurrencies.length === 1 ? fieldworkCurrencies[0] : '';
    this.EvaluatorCurrencies = evaluatorCurrencies;
    // Only set when the selection resolves to exactly one payment currency; the evaluator amount
    // fields stay disabled otherwise, and the server re-checks this across the full selection.
    this.EvCurrencyCode = evaluatorCurrencies.length === 1 ? evaluatorCurrencies[0] : '';
    this.JobIds = [];
    this.AllItemsInTheSearchSetAreSelected = false;
  }
}
